import { render } from "./Allergenes.vue?vue&type=template&id=6c4e6255"
import script from "./Allergenes.vue?vue&type=script&lang=js"
export * from "./Allergenes.vue?vue&type=script&lang=js"

import "./Allergenes.vue?vue&type=style&index=0&id=6c4e6255&lang=scss"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__